(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-elevation-profile", [], factory);
	else if(typeof exports === 'object')
		exports["map-elevation-profile"] = factory();
	else
		root["map-elevation-profile"] = factory();
})(self, function() {
return 